<template>
    <b-row class="asc__insertPage">
      <b-modal id="customer-add-modal" size="lg" hide-footer :title="$t('insert.loyalty.customerBulkOperations')">
      <MultipleCustomerAdd v-model="customers" />
    </b-modal>
     <b-col cols="12">
        <header>
          <b-row>
            <b-col cols="12" md="6">
              <Breadcrumb />
            </b-col>
            <b-col cols="12" md="6" class="text-right">
              <b-button size="sm" variant="warning" @click="$bvModal.show('price-list-excel-modal')" :title="$t('insert.PriceList.importExcel')">
                <i class="fa fa-upload"></i>
              </b-button>
              <router-link :to="{name: 'CustomPriceList' }">
                <CancelButton />
              </router-link>
              <AddButton @click.native="save()" />
            </b-col>
          </b-row>
        </header>
      </b-col>
      <b-col cols="12" class="asc__insertPage-content-head">
        <section>
          <b-row>
            <NextFormGroup item-key="Code" :error="$v.form.Code">
              <NextInput v-model="form.Code" type="text" disabled=true />
            </NextFormGroup>
            <NextFormGroup item-key="Description1" :error="$v.form.Description1">
              <NextInput v-model="form.Description1" type="text" :disabled="insertReadonly.Description1" />
            </NextFormGroup>
            <NextFormGroup item-key="StatusId" :error="$v.form.StatusId">
              <NextCheckBox v-model="form.StatusId" :disabled="insertReadonly.StatusId" type="number" toggle />
            </NextFormGroup>
          </b-row>
        </section>
      </b-col>
      <b-col cols="12" v-model="activeTabIndex">
        <b-tabs>
          <b-tab :title="$t('insert.PriceList.PriceList')">
            <b-row>
            <NextFormGroup item-key="CustomerCriteriaId" :error="$v.form.CustomerCriteriaId" md="4" lg="4">
              <NextDropdown v-model="customerCriteria" :disabled="insertReadonly.CustomerCriteriaId" lookup-key="CUSTOMER_CRITERIA" @input="selectedType('CustomerCriteriaId', $event)" label="Label" />
            </NextFormGroup>

            <NextFormGroup item-key="BranchCriteriaId" :error="$v.form.BranchCriteriaId" md="4" lg="4">
              <NextDropdown v-model="branchCriteria" :disabled="insertReadonly.BranchCriteriaId" @input="selectedType('BranchCriteriaId', $event)"  lookup-key="BRANCH_CRITERIA" label="Label" />
            </NextFormGroup>

            <NextFormGroup item-key="CurrencyId" :error="$v.form.CurrencyId" md="4" lg="4">
              <NextDropdown :disabled="insertReadonly.CurrencyId" url="VisionNextSystem/api/SysCurrency/Search" label="Description1" @input="selectedSearchType('CurrencyId', $event)"/>
            </NextFormGroup>

            <NextFormGroup item-key="BeginDate" :error="$v.form.BeginDate" md="4" lg="4">
              <NextDatePicker v-model="form.BeginDate" :disabled="insertReadonly.BeginDate" />
            </NextFormGroup>
            <NextFormGroup item-key="EndDate" :error="$v.form.EndDate" md="4" lg="4">
              <NextDatePicker v-model="form.EndDate" :disabled="insertReadonly.EndDate" />
            </NextFormGroup>

            <NextMultipleSelectionProducts
                name="CustomPriceListMultipleItem"
                v-model="products"
                @valuechange="updateCustomPriceListItems"/>
          </b-row>
          <hr />
            <!-- <b-row>
              <NextFormGroup :title="$t('insert.PriceList.Product')">
                <NextInput @input="onProductSearch($event)" type="text" ></NextInput>
              </NextFormGroup>
          </b-row> -->
          <b-row>
            <b-col cols="12">
              <b-table responsive autoWidth bordered small id="product-list" :per-page="20" :current-page="currentPage" :items="products" :fields="fields">
                <template #head()="data">
                  {{$t(data.label)}}
                </template>
                <template #cell(CustomPrice)="data">
                  <NextInput v-model="data.item.CustomPrice" type="number" :disabled="insertReadonly.ConsumerPrice"  toggle @keypress="keypress($event, data.item)"  @input="onConsumerPriceChange($event, data.item)" min="0"/>
                </template>
              </b-table>
              <b-pagination
                :total-rows="products.length"
                v-model="currentPage"
                :per-page="20"
                aria-controls="product-list"
              ></b-pagination>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab lazy :title="$t('insert.loyalty.branchs')" v-if="branchCriteria && branchCriteria.Code === 'SL'">
          <NextDetailPanel v-model="branchs" :items="loyaltyBranchItems" />
        </b-tab>

        <b-tab lazy :title="$t('insert.loyalty.customerCriterias')" v-if="customerCriteria && customerCriteria.Code === 'MK'">
          <NextDetailPanel v-model="customerCriterias" :items="loyaltyCustomerCriteriaItems" />
        </b-tab>

        <b-tab lazy :title="$t('insert.loyalty.customers')" @click.prevent="customersTabClicked" v-if="customerCriteria && customerCriteria.Code === 'ML'">
          <b-col cols="12" md="12">
              <b-form-group class="text-right">
                <b-button v-b-modal.customer-add-modal class="mt-1" size="sm" variant="success"><i class="fa fa-list"></i> {{$t('insert.loyalty.customerBulkOperations')}}</b-button>
              </b-form-group>
            </b-col>
          <NextDetailPanel v-model="customers" :items="getLoyaltyCustomerItems()" />
        </b-tab>


        </b-tabs>
      </b-col>
      <PriceListExcelModal @update="updatePriceListFromExcel" />
    </b-row>
  </template>
  <script>
  import updateMixin from '../../mixins/update'
  import { detailData } from './detailPanelData'
  import PriceListExcelModal from '../../components/Actions/PriceListExcelModal'
  import { mapState } from 'vuex';
  import MultipleCustomerAdd from './MultipleCustomerAdd'
  export default {
    mixins: [updateMixin],
    components: {
      PriceListExcelModal,
      MultipleCustomerAdd
    },
    data () {
      return {
        form: {
            Deleted: 0,
          System: 0,
          RecordState: 2,
          CurrencyId: null,
          BranchCriteriaId: null,
          CustomerCriteriaId:null,
          BeginDate: null,
          EndDate: null,
          PriceListCategoryId: null,
          StatusId: 1,
          RecordId: null,
          EncryptedKey: null,
          Code: null,
          Description1: null,
          CustomPriceListItems: null,
          CustomPriceListBranch:[],
          CustomPriceListCustCrts:[],
          CustomPriceListCustomers:[]
        },
        priceListCategory: null,
        currency: null,

        branchCriteria:null,
        customerCriteria: null,
        loyaltyBranchItems: detailData.loyaltyBranchItems,
        loyaltyCustomerCriteriaItems: detailData.loyaltyCustomerCriteriaItems,
        routeName1: 'Finance',
        branchs: [],
        intialBranches:[],
        customerCriterias: [],
        customers: [],
        products: [],
        productsCopy : [],
        allUserProducts: [],
        currentPage: 1,
        activeTabIndex: 0,
        fields: [
          {
            key: 'Code',
            label: this.$t('insert.PriceList.ProductCode'),
            thClass: 'list-textbox-width'
          },
          {
            key: 'Description1',
            label: this.$t('insert.PriceList.ProductName'),
            thClass: 'list-textbox-width'
          },
        //   {
        //     key: 'IsVatIncluded',
        //     label: this.$t('insert.PriceList.IsVatIncluded'),
        //     thClass: 'list-checkbox-width'
        //   },
        //   {
        //     key: 'UseConsumerPrice',
        //     label: this.$t('insert.PriceList.UseConsumerPrice'),
        //     thClass: 'list-checkbox-width'
        //   },
        //   {
        //     key: 'SalesPrice',
        //     label: this.$t('insert.PriceList.SalesPrice'),
        //     thClass: 'list-textbox-width'
        //   },
          {
            key: 'CustomPrice',
            label: this.$t('insert.CustomPriceList.CustomListPrice'),
            thClass: 'list-textbox-width'
          }
        ]
      }
    },
    computed: {
      ...mapState(['lookup']),
    },
    mounted () {
      this.getData().then(() => {
        this.setData()
        //this.getLists()
      })
      this.getCustomPriceListCustomers();
    },
    methods: {
        setData () {
      let rowData = this.rowData
      if (rowData) {
        this.$store.commit('setGetCreateCode', rowData.Code)
        this.showDetails = true
        this.form = rowData
        this.customerCriteria = rowData.CustomerCriteria
        this.branchCriteria = rowData.BranchCriteria
        this.products = rowData.CustomPriceListItems
        this.productsCopy = this.products
        this.branchs = this.form.CustomPriceListBranch.map(item => ({
        BranchId: item.Branch.Value,
        BranchName: item.Branch.Label,
        Deleted: 0,
        System: 0,
        RecordState: 1,
        StatusId: 1,
        BranchIdDesc: item.Branch.Code
      }));
      this.intialBranches = [...this.branchs]
      this.customerCriterias = this.form.CustomPriceListCustCrts.map(item => ({
        ColumnName: item.ColumnName,
        ColumnValue: item.ColumnValue,
        ColumnNameDesc: item.ColumnNameDesc,
        ColumnValueDesc: item.ColumnValueDesc,
        Deleted: 0,
        RecordState: 2,
        StatusId: 1,
        System: 0,
        TableName: item.TableName
      }));
      }
    },
    filterCriteria() {
      if (this.lookup.BRANCH_CRITERIA || this.lookup.CUSTOMER_CRITERIA) {
          this.lookup.BRANCH_CRITERIA = this.lookup.BRANCH_CRITERIA.filter(option => option.Code !== 'TS');
          this.lookup.CUSTOMER_CRITERIA = this.lookup.CUSTOMER_CRITERIA.filter(option => option.Code !== 'MS' && option.Code !== 'MK');
        }
      },
      save () {
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          this.$toasted.show(this.$t('insert.requiredFields'), {
            type: 'error',
            keepOnHover: true,
            duration: '3000'
          })
          this.tabValidation()
        } else {
          this.form.CustomPriceListItems = [...this.products]
          this.form.CustomPriceListBranch = [...this.branchs]
          this.form.CustomPriceListCustCrts = [...this.customerCriterias]
          this.form.CustomPriceListCustomers = [...this.customers]
          this.form.StatusId = this.form.StatusId === true || this.form.StatusId === 1 ? 1 : 2
          this.updateData()
        }
      },
      updateCustomPriceListItems(selectedProducts) {
        selectedProducts = selectedProducts.map(item => {
          var newItem = {
              Deleted: 0,
              System: 0,
              RecordState: item.RecordState,
              CompanyId: 1,
              StatusId: 1,
              ItemId: item.RecordId,
              IsVatIncluded: item.IsVatIncluded ? item.IsVatIncluded : 0,
              SalesPrice: item.SalesPrice,
              CustomPrice: item.ConsumerPrice,
              Code: item.Code,
              Description1: item.Description1
            };
            return newItem;
        })

        var tempProductsCopy = []

        selectedProducts.forEach((selectedProduct) => {
        const originalIndex = this.productsCopy.findIndex((originalItem) => originalItem.ItemId === selectedProduct.ItemId);
    
          if (originalIndex !== -1) {
            this.$set(this.productsCopy[originalIndex], 'RecordState', selectedProduct.RecordState);
            this.$set(this.productsCopy[originalIndex], 'CustomPrice', selectedProduct.CustomPrice);
            tempProductsCopy.push(this.productsCopy[originalIndex]);
          }else{
             tempProductsCopy.push(selectedProduct);
          }
        });
        this.products = tempProductsCopy
      },
      onConsumerPriceChange(value, item) {
        if (+(value) > 0) {
          const existingItemIndex = this.products.findIndex(
            (p) => p.ItemId === item.ItemId);
          if (existingItemIndex !== -1) {
            this.products[existingItemIndex].CustomPrice = value;
            this.products[existingItemIndex].RecordState = 3;
          }
        }
      },
      keypress(event, item) {
        const key = event.key;

        // Allow only numbers, decimal point, and control keys
        const isNumber = /\d/.test(key);
        const isDecimal = key === '.';
        const isBackspace = key === 'Backspace' || key === 'Delete';
        const isArrowKey = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(key);
        
        // Get current input value and prepare for the new input
        const currentValue = item.CustomPrice || '';

        // Prevent entering if the key is not a valid input
        if (!isNumber && !isDecimal && !isBackspace && !isArrowKey) {
          event.preventDefault();
          return;
        }

        // Handle the decimal input logic
        if (isDecimal) {
          // Allow one decimal point
          if (currentValue.includes('.')) {
            event.preventDefault();
          }
        }

        // Check how many digits are after the decimal
        const decimalIndex = currentValue.indexOf('.');
        const digitsAfterDecimal = decimalIndex === -1 ? 0 : currentValue.length - decimalIndex - 1;

        // If a decimal point is present, restrict digits after it to 2
        if (decimalIndex !== -1 && digitsAfterDecimal >= 2 && !isBackspace) {
          event.preventDefault();
        }
      },
      getLists (type) {
        if (type === 'button' && (!this.form.CurrencyId || !this.form.PriceListCategoryId)) {
          this.$toasted.show(this.$t('insert.PriceList.getLastProductError'), {
            type: 'error',
            keepOnHover: true,
            duration: '3000'
          })
          return
        }
        let request = {
          Model: {
            CurrencyId: this.form.CurrencyId,
            PriceListCategoryId: this.form.PriceListCategoryId
          }
        }
        this.$api.postByUrl(request, 'VisionNextItem/api/Item/ItemForNewPriceList').then(response => {
          if (response.Model) {
            this.allProducts = response.Model
            this.mergeLists(this.allProducts)
          }
        })
      },
      // onProductSearch (value) {
      //   if (!value || value === '') {
      //     this.products = this.allUserProducts
      //   } else {
      //     this.products = this.allUserProducts.filter(p => p.Description1 ? p.Description1.toLocaleLowerCase().includes(value.toLocaleLowerCase()) : false)
      //   }
      // },
      customersTabClicked () {
      if (!this.branchCriteria) {
        this.$toasted.show(this.$t('insert.loyalty.pleaseFirstSelectBranchCriteria'), {
          type: 'error',
          keepOnHover: true,
          duration: '3000'
        })
        setTimeout(() => {
          this.activeTabIndex = 0
        }, 1)
      } else if (this.branchCriteria.Code === 'SL' && this.branchs.length === 0) {
        this.$toasted.show(this.$t('insert.loyalty.pleaseFirstSelectBranch'), {
          type: 'error',
          keepOnHover: true,
          duration: '3000'
        })
        setTimeout(() => {
          this.activeTabIndex = 3
        }, 1)
      }
    },
      getLoyaltyCustomerItems () {
      return [
      {
          type: 'Autocomplete',
          modelProperty: 'CustomerId',
          objectKey: 'ColumnNameDesc',
          labelProperty: 'RecordId',
          customOption: true,
          isCustomer: true,
          orConditionFields: 'Code,Description1',
          url: 'VisionNextCustomer/api/Customer/GetBranchesCustomerSearch',
          label: this.$t('insert.loyalty.customerCode'),
          dynamicAndCondition: this.branchs.length > 0 ? { BranchIds: this.branchs.map(b => b.BranchId) } : {},
          required: true,
          visible: true,
          isUnique: true,
          id: 1
        },
        {
          type: 'Label',
          inputType: 'text',
          modelProperty: 'Description1',
          objectKey: 'ColumnValueDesc',
          parentProperty: 'Description1',
          label: this.$t('insert.loyalty.customerName'),
          visible: true,
          disabled: true,
          parentId: 1,
          id: 2
        },
      ]
    },
    getCustomPriceListCustomers () {
      let pagerecordCount = 1000
      let request = {
        AndConditionModel: {
            CustomPriceListIds: [this.$route.params.url]
        }
      }
      this.$api.postByUrl(request, 'VisionNextFinance/api/CustomPriceListCustomer/Search', pagerecordCount).then(response => {
        if (response && response.ListModel) {
          let list = response.ListModel.BaseModels
          this.customers = list.map(item => ({
                    CustomerId: item.CustomerId,
                    Description1: item.Customer.Label,
                    CustomerIdDesc: item.Customer.Code,
                    Deleted:0,
                    RecordState:2,
                    StatusId:1,
                    System:0
               }));
          this.customerCriterias = list.filter(i => i.TableName === 'T_CUSTOMER' && i.ColumnName !== 'RECORD_ID')
        }
      })
    },
      mergeLists () {
        this.allUserProducts = this.allProducts.map((product) => {
          var selectedProduct = this.userProducts.find(p => p.ItemId === product.ItemRecordId)
          if (selectedProduct) {
            product.SalesPrice = selectedProduct.SalesPrice
            product.ConsumerPrice = selectedProduct.CustomPrice
            product.UseConsumerPrice = selectedProduct.UseConsumerPrice
            product.IsVatIncluded = selectedProduct.IsVatIncluded
            product.RecordId = selectedProduct.RecordId
            product.PriceListId = selectedProduct.CustomPriceListId
          }
          return product
        })
        this.products = this.allUserProducts
      },
      updatePriceListFromExcel(excelData) {
        let passiveProductError = false;
        const excelProducts = excelData.map(row => {
          return {
            ItemCode: row.CODE,
            ConsPrice: typeof row.CUSTOM_PRICE === 'string' ? Math.abs(parseFloat(row.CUSTOM_PRICE)) : Math.abs(row.CUSTOM_PRICE),
          };
        });
        excelProducts.forEach(item => {
            this.products.forEach(product => { 
              if (
               item.ItemCode  ==  product.Code &&
              product.StatusId !== 2 
            ) {
              if (!this.isValidPrice(item.ConsPrice)) {
                  item.ConsPrice = +(this.roundPriceToTwoDecimal(item.ConsPrice));
                  this.onConsumerPriceChange(item.ConsPrice, product);
                } else { 
                  this.onConsumerPriceChange(item.ConsPrice, product); 
                }
              } else if (product.Item.StatusId === 2) {
                passiveProductError = true;
              }
            });
          });
          if (passiveProductError) {
            this.$toasted.show(this.$t('general.failFileUploadPassiveProduct'), {
              type: 'error',
              keepOnHover: true,
              duration: '3000'
            });
          }  else {
          this.$toasted.show(this.$t('general.successFileUpload'), {
            type: 'success',
            keepOnHover: true,
            duration: '3000'
          });
        }
         this.$root.$emit('bv::hide::modal', 'price-list-excel-modal');
    },
    isValidPrice(price) {
      const priceRegex = /^\d+(\.\d{1,2})?$/;
      return priceRegex.test(price);
    },
    roundPriceToTwoDecimal(price) {
      const parsedPrice = parseFloat(price);
      if (isNaN(parsedPrice)) {
          return 0;  
      }
      return +(Math.round(parsedPrice * 100) / 100).toFixed(2);
    }
     },
    watch: {
      rowData (e) {
        if (e) {
          this.form.Deleted = e.Deleted
          this.form.System = e.System
          this.form.RecordState = e.RecordState
          this.form.CurrencyId = e.CurrencyId
          this.form.BeginDate = e.BeginDate
          this.form.EndDate = e.EndDate
          this.form.PriceListCategoryId = e.PriceListCategoryId
          this.form.StatusId = e.StatusId
          this.form.RecordId = e.RecordId
          this.form.EncryptedKey = e.EncryptedKey
          this.form.Code = e.Code
          this.form.Description1 = e.Description1
          this.priceListCategory = e.PriceListCategory
          this.currency = this.convertLookupValueToSearchValue(e.Currency)
          this.userProducts = e.CustomPriceListItems
        }
      },
      lookup: {
        handler(newVal) {
          if (newVal.BRANCH_CRITERIA || newVal.CUSTOMER_CRITERIA) {
            this.filterCriteria();
          }
        },
        deep: false,
        immediate: false
      },
      currencies (value) {
        if (value) {
          this.currency = value.find(c => c.RecordId === this.form.CurrencyId)
        }
      }
    }
  }
  </script>
  <style lang="css">
  .list-checkbox-width{
    width: 10% !important
  }
  .list-textbox-width{
    width: 20% !important
  }
  </style>
  


// WEBPACK FOOTER //
// src/pages/CustomPriceList/update.vue